<div class="chart-wrapper">
    <canvas baseChart
        [datasets]="radarChartData"
        [options]="radarChartOptions"
        [labels]="radarChartLabels"
        [type]="radarChartType">
    </canvas>
</div>